// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1Jhxa","errors":"Errors_errors__3Z_6A"};